import React from 'react';

/**
 * SheetHeader component for displaying column headers in the band sheet
 * Hidden on mobile devices since Part component has its own labels
 */
const SheetHeader = () => {
  
  return (
    <div className="hidden md:flex border-b border-gray-300 font-bold bg-white text-sm text-gray-800 relative">
      <div className="w-[100px] min-w-[100px] px-3 py-2 flex items-center">Section</div>
      <div className="w-[50px] min-w-[50px] px-2 py-2 flex items-center">Part</div>
      <div className="w-[50px] min-w-[50px] px-2 py-2 flex items-center">Bars</div>
      <div className="flex-1 px-2 py-2 flex items-center">Lyrics</div>
      <div className="w-[150px] min-w-[150px] px-2 py-2 flex items-center">Notes</div>
      <div className="w-[40px] min-w-[40px] px-2 py-2 pr-6 flex justify-center items-center"></div>
    </div>
  );
};

export default SheetHeader;
